<p-table [value]="products" dataKey="id">
    <ng-template pTemplate="header">
        <tr>
            <th style="width: 3rem"></th>
            <th>Name</th>
            <th>Is Active</th>
            <th>Markup/Discount(%)</th>
            <th>Action</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product let-expanded="expanded">
        <tr class="parentRow" *ngIf="product.name == discountQtyType" >
            <td class="action">
                <button type="button" pButton pRipple [pRowToggler]="product" 
                class="p-button-text p-button-rounded p-button-plain" 
                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
            </td>
            <td>{{product.name}}</td>
            <td colspan="2"></td>
            <td>
                <span class="btnBars p-mr-0" (click)="openProducts(product)" 
                pTooltip="View" tooltipPosition="top">
                    <i class="pi pi-microsoft"></i>
                </span>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-product>
        <tr *ngFor="let child of product.childPriceTier; let i =index;">
            <ng-container *ngIf="child.isVisible">
                <td></td>
                <td>{{child.name}}</td>
                <td>{{child.statusId==statusConstants.ACTIVE?answertypeConstants.Yes:answertypeConstants.No}}</td>
                <td>{{child.markup}}%</td>
                <td class="action">
                    <span class="btnBars p-mr-0" *ngIf="product.name == discountGroupType" (click)="addTierToGroup(product)"
                    pTooltip="Add" tooltipPosition="top">
                        <i class="pi pi-plus"></i>
                    </span>
                    <span class="btnBars p-mr-0" (click)="showEditPricing(child)" 
                    pTooltip="Edit" tooltipPosition="top">
                        <i class="pi pi-pencil"></i>
                    </span>
                    <span class="btnBars p-mr-0" pTooltip="Delete" tooltipPosition="top" (click)="deleteTier(product,child,i)">
                        <i class="pi pi-trash"></i>
                    </span>
                </td>
            </ng-container>
               
        </tr>
    </ng-template>
</p-table>






